module.exports = __webpack_public_path__ + "static/media/ic-close-typing-24.7c73fd8f.svg";